(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.AgnosticViewNav = {}));
}(this, (function (exports) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function noop() {}

  function assign(tar, src) {
    for (var k in src) {
      tar[k] = src[k];
    }

    return tar;
  }

  function assignTrue(tar, src) {
    for (var k in src) {
      tar[k] = 1;
    }

    return tar;
  }

  function run(fn) {
    fn();
  }

  function append(target, node) {
    target.appendChild(node);
  }

  function insert(target, node, anchor) {
    target.insertBefore(node, anchor);
  }

  function detachNode(node) {
    node.parentNode.removeChild(node);
  }

  function createElement(name) {
    return document.createElement(name);
  }

  function createText(data) {
    return document.createTextNode(data);
  }

  function createComment() {
    return document.createComment('');
  }

  function addListener(node, event, handler, options) {
    node.addEventListener(event, handler, options);
  }

  function removeListener(node, event, handler, options) {
    node.removeEventListener(event, handler, options);
  }

  function setAttribute(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);else node.setAttribute(attribute, value);
  }

  function setData(text, data) {
    text.data = '' + data;
  }

  function toggleClass(element, name, toggle) {
    element.classList[toggle ? 'add' : 'remove'](name);
  }

  function linear(t) {
    return t;
  }

  function generateRule(_ref, ease, fn) {
    var a = _ref.a,
        b = _ref.b,
        delta = _ref.delta,
        duration = _ref.duration;
    var step = 16.666 / duration;
    var keyframes = '{\n';

    for (var p = 0; p <= 1; p += step) {
      var t = a + delta * ease(p);
      keyframes += p * 100 + "%{".concat(fn(t, 1 - t), "}\n");
    }

    return keyframes + "100% {".concat(fn(b, 1 - b), "}\n}");
  } // https://github.com/darkskyapp/string-hash/blob/master/index.js


  function hash(str) {
    var hash = 5381;
    var i = str.length;

    while (i--) {
      hash = (hash << 5) - hash ^ str.charCodeAt(i);
    }

    return hash >>> 0;
  }

  function wrapTransition(component, node, fn, params, intro) {
    var obj = fn.call(component, node, params);
    var duration;
    var ease;
    var cssText;
    var initialised = false;
    return {
      t: intro ? 0 : 1,
      running: false,
      program: null,
      pending: null,
      run: function run(b, callback) {
        var _this = this;

        if (typeof obj === 'function') {
          transitionManager.wait().then(function () {
            obj = obj();

            _this._run(b, callback);
          });
        } else {
          this._run(b, callback);
        }
      },
      _run: function _run(b, callback) {
        duration = obj.duration || 300;
        ease = obj.easing || linear;
        var program = {
          start: window.performance.now() + (obj.delay || 0),
          b: b,
          callback: callback || noop
        };

        if (intro && !initialised) {
          if (obj.css && obj.delay) {
            cssText = node.style.cssText;
            node.style.cssText += obj.css(0, 1);
          }

          if (obj.tick) obj.tick(0, 1);
          initialised = true;
        }

        if (!b) {
          program.group = outros.current;
          outros.current.remaining += 1;
        }

        if (obj.delay) {
          this.pending = program;
        } else {
          this.start(program);
        }

        if (!this.running) {
          this.running = true;
          transitionManager.add(this);
        }
      },
      start: function start(program) {
        component.fire("".concat(program.b ? 'intro' : 'outro', ".start"), {
          node: node
        });
        program.a = this.t;
        program.delta = program.b - program.a;
        program.duration = duration * Math.abs(program.b - program.a);
        program.end = program.start + program.duration;

        if (obj.css) {
          if (obj.delay) node.style.cssText = cssText;
          var rule = generateRule(program, ease, obj.css);
          transitionManager.addRule(rule, program.name = '__svelte_' + hash(rule));
          node.style.animation = (node.style.animation || '').split(', ').filter(function (anim) {
            return anim && (program.delta < 0 || !/__svelte/.test(anim));
          }).concat("".concat(program.name, " ").concat(program.duration, "ms linear 1 forwards")).join(', ');
        }

        this.program = program;
        this.pending = null;
      },
      update: function update(now) {
        var program = this.program;
        if (!program) return;
        var p = now - program.start;
        this.t = program.a + program.delta * ease(p / program.duration);
        if (obj.tick) obj.tick(this.t, 1 - this.t);
      },
      done: function done() {
        var program = this.program;
        this.t = program.b;
        if (obj.tick) obj.tick(this.t, 1 - this.t);
        component.fire("".concat(program.b ? 'intro' : 'outro', ".end"), {
          node: node
        });

        if (!program.b && !program.invalidated) {
          program.group.callbacks.push(function () {
            program.callback();
            if (obj.css) transitionManager.deleteRule(node, program.name);
          });

          if (--program.group.remaining === 0) {
            program.group.callbacks.forEach(run);
          }
        } else {
          if (obj.css) transitionManager.deleteRule(node, program.name);
        }

        this.running = !!this.pending;
      },
      abort: function abort(reset) {
        if (this.program) {
          if (reset && obj.tick) obj.tick(1, 0);
          if (obj.css) transitionManager.deleteRule(node, this.program.name);
          this.program = this.pending = null;
          this.running = false;
        }
      },
      invalidate: function invalidate() {
        if (this.program) {
          this.program.invalidated = true;
        }
      }
    };
  }

  var outros = {};

  function groupOutros() {
    outros.current = {
      remaining: 0,
      callbacks: []
    };
  }

  var transitionManager = {
    running: false,
    transitions: [],
    bound: null,
    stylesheet: null,
    activeRules: {},
    promise: null,
    add: function add(transition) {
      this.transitions.push(transition);

      if (!this.running) {
        this.running = true;
        requestAnimationFrame(this.bound || (this.bound = this.next.bind(this)));
      }
    },
    addRule: function addRule(rule, name) {
      if (!this.stylesheet) {
        var style = createElement('style');
        document.head.appendChild(style);
        transitionManager.stylesheet = style.sheet;
      }

      if (!this.activeRules[name]) {
        this.activeRules[name] = true;
        this.stylesheet.insertRule("@keyframes ".concat(name, " ").concat(rule), this.stylesheet.cssRules.length);
      }
    },
    next: function next() {
      this.running = false;
      var now = window.performance.now();
      var i = this.transitions.length;

      while (i--) {
        var transition = this.transitions[i];

        if (transition.program && now >= transition.program.end) {
          transition.done();
        }

        if (transition.pending && now >= transition.pending.start) {
          transition.start(transition.pending);
        }

        if (transition.running) {
          transition.update(now);
          this.running = true;
        } else if (!transition.pending) {
          this.transitions.splice(i, 1);
        }
      }

      if (this.running) {
        requestAnimationFrame(this.bound);
      } else if (this.stylesheet) {
        var _i = this.stylesheet.cssRules.length;

        while (_i--) {
          this.stylesheet.deleteRule(_i);
        }

        this.activeRules = {};
      }
    },
    deleteRule: function deleteRule(node, name) {
      node.style.animation = node.style.animation.split(', ').filter(function (anim) {
        return anim && anim.indexOf(name) === -1;
      }).join(', ');
    },
    wait: function wait() {
      if (!transitionManager.promise) {
        transitionManager.promise = Promise.resolve();
        transitionManager.promise.then(function () {
          transitionManager.promise = null;
        });
      }

      return transitionManager.promise;
    }
  };

  function destroyBlock(block, lookup) {
    block.d(1);
    lookup[block.key] = null;
  }

  function updateKeyedEach(old_blocks, component, changed, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, intro_method, next, get_context) {
    var o = old_blocks.length;
    var n = list.length;
    var i = o;
    var old_indexes = {};

    while (i--) {
      old_indexes[old_blocks[i].key] = i;
    }

    var new_blocks = [];
    var new_lookup = {};
    var deltas = {};
    var i = n;

    while (i--) {
      var child_ctx = get_context(ctx, list, i);
      var key = get_key(child_ctx);
      var block = lookup[key];

      if (!block) {
        block = create_each_block(component, key, child_ctx);
        block.c();
      } else if (dynamic) {
        block.p(changed, child_ctx);
      }

      new_blocks[i] = new_lookup[key] = block;
      if (key in old_indexes) deltas[key] = Math.abs(i - old_indexes[key]);
    }

    var will_move = {};
    var did_move = {};

    function insert(block) {
      block[intro_method](node, next);
      lookup[block.key] = block;
      next = block.first;
      n--;
    }

    while (o && n) {
      var new_block = new_blocks[n - 1];
      var old_block = old_blocks[o - 1];
      var new_key = new_block.key;
      var old_key = old_block.key;

      if (new_block === old_block) {
        // do nothing
        next = new_block.first;
        o--;
        n--;
      } else if (!new_lookup[old_key]) {
        // remove old block
        destroy(old_block, lookup);
        o--;
      } else if (!lookup[new_key] || will_move[new_key]) {
        insert(new_block);
      } else if (did_move[old_key]) {
        o--;
      } else if (deltas[new_key] > deltas[old_key]) {
        did_move[new_key] = true;
        insert(new_block);
      } else {
        will_move[old_key] = true;
        o--;
      }
    }

    while (o--) {
      var old_block = old_blocks[o];
      if (!new_lookup[old_block.key]) destroy(old_block, lookup);
    }

    while (n) {
      insert(new_blocks[n - 1]);
    }

    return new_blocks;
  }

  function blankObject() {
    return Object.create(null);
  }

  function destroy(detach) {
    this.destroy = noop;
    this.fire('destroy');
    this.set = noop;

    this._fragment.d(detach !== false);

    this._fragment = null;
    this._state = {};
  }

  function _differs(a, b) {
    return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
  }

  function fire(eventName, data) {
    var handlers = eventName in this._handlers && this._handlers[eventName].slice();

    if (!handlers) return;

    for (var i = 0; i < handlers.length; i += 1) {
      var handler = handlers[i];

      if (!handler.__calling) {
        try {
          handler.__calling = true;
          handler.call(this, data);
        } finally {
          handler.__calling = false;
        }
      }
    }
  }

  function flush(component) {
    component._lock = true;
    callAll(component._beforecreate);
    callAll(component._oncreate);
    callAll(component._aftercreate);
    component._lock = false;
  }

  function get() {
    return this._state;
  }

  function init(component, options) {
    component._handlers = blankObject();
    component._slots = blankObject();
    component._bind = options._bind;
    component._staged = {};
    component.options = options;
    component.root = options.root || component;
    component.store = options.store || component.root.store;

    if (!options.root) {
      component._beforecreate = [];
      component._oncreate = [];
      component._aftercreate = [];
    }
  }

  function on(eventName, handler) {
    var handlers = this._handlers[eventName] || (this._handlers[eventName] = []);
    handlers.push(handler);
    return {
      cancel: function cancel() {
        var index = handlers.indexOf(handler);
        if (~index) handlers.splice(index, 1);
      }
    };
  }

  function set(newState) {
    this._set(assign({}, newState));

    if (this.root._lock) return;
    flush(this.root);
  }

  function _set(newState) {
    var oldState = this._state,
        changed = {},
        dirty = false;
    newState = assign(this._staged, newState);
    this._staged = {};

    for (var key in newState) {
      if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
    }

    if (!dirty) return;
    this._state = assign(assign({}, oldState), newState);

    this._recompute(changed, this._state);

    if (this._bind) this._bind(changed, this._state);

    if (this._fragment) {
      this.fire("state", {
        changed: changed,
        current: this._state,
        previous: oldState
      });

      this._fragment.p(changed, this._state);

      this.fire("update", {
        changed: changed,
        current: this._state,
        previous: oldState
      });
    }
  }

  function _stage(newState) {
    assign(this._staged, newState);
  }

  function callAll(fns) {
    while (fns && fns.length) {
      fns.shift()();
    }
  }

  function _mount(target, anchor) {
    this._fragment[this._fragment.i ? 'i' : 'm'](target, anchor || null);
  }

  var proto = {
    destroy: destroy,
    get: get,
    fire: fire,
    on: on,
    set: set,
    _recompute: noop,
    _set: _set,
    _stage: _stage,
    _mount: _mount,
    _differs: _differs
  };

  function cubicOut(t) {
    var f = t - 1.0;
    return f * f * f + 1.0
  }

  function slide(
  	node,
  	ref
  ) {
  	var delay = ref.delay; if ( delay === void 0 ) delay = 0;
  	var duration = ref.duration; if ( duration === void 0 ) duration = 400;
  	var easing = ref.easing; if ( easing === void 0 ) easing = cubicOut;

  	var style = getComputedStyle(node);
  	var opacity = +style.opacity;
  	var height = parseFloat(style.height);
  	var paddingTop = parseFloat(style.paddingTop);
  	var paddingBottom = parseFloat(style.paddingBottom);
  	var marginTop = parseFloat(style.marginTop);
  	var marginBottom = parseFloat(style.marginBottom);
  	var borderTopWidth = parseFloat(style.borderTopWidth);
  	var borderBottomWidth = parseFloat(style.borderBottomWidth);

  	return {
  		delay: delay,
  		duration: duration,
  		easing: easing,
  		css: function (t) { return "overflow: hidden;" +
  			"opacity: " + (Math.min(t * 20, 1) * opacity) + ";" +
  			"height: " + (t * height) + "px;" +
  			"padding-top: " + (t * paddingTop) + "px;" +
  			"padding-bottom: " + (t * paddingBottom) + "px;" +
  			"margin-top: " + (t * marginTop) + "px;" +
  			"margin-bottom: " + (t * marginBottom) + "px;" +
  			"border-top-width: " + (t * borderTopWidth) + "px;" +
  			"border-bottom-width: " + (t * borderBottomWidth) + "px;"; }
  	};
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** `Object#toString` result references. */
  var funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      symbolTag = '[object Symbol]';

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }
    return result;
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString = objectProto.toString;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /** Built-in value references. */
  var Symbol$1 = root.Symbol,
      splice = arrayProto.splice;

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash,
      'map': new (Map || ListCache),
      'string': new Hash
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object));
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoize(function(string) {
    string = toString(string);

    var result = [];
    if (reLeadingDot.test(string)) {
      result.push('');
    }
    string.replace(rePropName, function(match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
  });

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
  }

  // Assign cache to `_.memoize`.
  memoize.Cache = MapCache;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' ||
      (isObjectLike(value) && objectToString.call(value) == symbolTag);
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get$1(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  var lodash_get = get$1;

  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT$1 = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

  /** Used as references for various `Number` constants. */
  var INFINITY$1 = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991;

  /** `Object#toString` result references. */
  var funcTag$1 = '[object Function]',
      genTag$1 = '[object GeneratorFunction]',
      symbolTag$1 = '[object Symbol]';

  /** Used to match property names within property paths. */
  var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp$1 = /^\w*$/,
      reLeadingDot$1 = /^\./,
      rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar$1 = /\\(\\)?/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue$1(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject$1(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }
    return result;
  }

  /** Used for built-in method references. */
  var arrayProto$1 = Array.prototype,
      funcProto$1 = Function.prototype,
      objectProto$1 = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData$1 = root$1['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey$1 = (function() {
    var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /** Used to resolve the decompiled source of functions. */
  var funcToString$1 = funcProto$1.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString$1 = objectProto$1.toString;

  /** Used to detect if a method is native. */
  var reIsNative$1 = RegExp('^' +
    funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar$1, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /** Built-in value references. */
  var Symbol$2 = root$1.Symbol,
      splice$1 = arrayProto$1.splice;

  /* Built-in method references that are verified to be native. */
  var Map$1 = getNative$1(root$1, 'Map'),
      nativeCreate$1 = getNative$1(Object, 'create');

  /** Used to convert symbols to primitives and strings. */
  var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
      symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash$1(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear$1() {
    this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete$1(key) {
    return this.has(key) && delete this.__data__[key];
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet$1(key) {
    var data = this.__data__;
    if (nativeCreate$1) {
      var result = data[key];
      return result === HASH_UNDEFINED$1 ? undefined : result;
    }
    return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas$1(key) {
    var data = this.__data__;
    return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet$1(key, value) {
    var data = this.__data__;
    data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$1 : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash$1.prototype.clear = hashClear$1;
  Hash$1.prototype['delete'] = hashDelete$1;
  Hash$1.prototype.get = hashGet$1;
  Hash$1.prototype.has = hashHas$1;
  Hash$1.prototype.set = hashSet$1;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache$1(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear$1() {
    this.__data__ = [];
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete$1(key) {
    var data = this.__data__,
        index = assocIndexOf$1(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice$1.call(data, index, 1);
    }
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet$1(key) {
    var data = this.__data__,
        index = assocIndexOf$1(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas$1(key) {
    return assocIndexOf$1(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet$1(key, value) {
    var data = this.__data__,
        index = assocIndexOf$1(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache$1.prototype.clear = listCacheClear$1;
  ListCache$1.prototype['delete'] = listCacheDelete$1;
  ListCache$1.prototype.get = listCacheGet$1;
  ListCache$1.prototype.has = listCacheHas$1;
  ListCache$1.prototype.set = listCacheSet$1;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache$1(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear$1() {
    this.__data__ = {
      'hash': new Hash$1,
      'map': new (Map$1 || ListCache$1),
      'string': new Hash$1
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete$1(key) {
    return getMapData$1(this, key)['delete'](key);
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet$1(key) {
    return getMapData$1(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas$1(key) {
    return getMapData$1(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet$1(key, value) {
    getMapData$1(this, key).set(key, value);
    return this;
  }

  // Add methods to `MapCache`.
  MapCache$1.prototype.clear = mapCacheClear$1;
  MapCache$1.prototype['delete'] = mapCacheDelete$1;
  MapCache$1.prototype.get = mapCacheGet$1;
  MapCache$1.prototype.has = mapCacheHas$1;
  MapCache$1.prototype.set = mapCacheSet$1;

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty$1.call(object, key) && eq$1(objValue, value)) ||
        (value === undefined && !(key in object))) {
      object[key] = value;
    }
  }

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf$1(array, key) {
    var length = array.length;
    while (length--) {
      if (eq$1(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative$1(value) {
    if (!isObject$1(value) || isMasked$1(value)) {
      return false;
    }
    var pattern = (isFunction$1(value) || isHostObject$1(value)) ? reIsNative$1 : reIsHostCtor$1;
    return pattern.test(toSource$1(value));
  }

  /**
   * The base implementation of `_.set`.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to set.
   * @param {Function} [customizer] The function to customize path creation.
   * @returns {Object} Returns `object`.
   */
  function baseSet(object, path, value, customizer) {
    if (!isObject$1(object)) {
      return object;
    }
    path = isKey$1(path, object) ? [path] : castPath$1(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;

    while (nested != null && ++index < length) {
      var key = toKey$1(path[index]),
          newValue = value;

      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = customizer ? customizer(objValue, key, nested) : undefined;
        if (newValue === undefined) {
          newValue = isObject$1(objValue)
            ? objValue
            : (isIndex(path[index + 1]) ? [] : {});
        }
      }
      assignValue(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString$1(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isSymbol$1(value)) {
      return symbolToString$1 ? symbolToString$1.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
  }

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath$1(value) {
    return isArray$1(value) ? value : stringToPath$1(value);
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData$1(map, key) {
    var data = map.__data__;
    return isKeyable$1(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative$1(object, key) {
    var value = getValue$1(object, key);
    return baseIsNative$1(value) ? value : undefined;
  }

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length &&
      (typeof value == 'number' || reIsUint.test(value)) &&
      (value > -1 && value % 1 == 0 && value < length);
  }

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey$1(value, object) {
    if (isArray$1(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol$1(value)) {
      return true;
    }
    return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
      (object != null && value in Object(object));
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable$1(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked$1(func) {
    return !!maskSrcKey$1 && (maskSrcKey$1 in func);
  }

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath$1 = memoize$1(function(string) {
    string = toString$1(string);

    var result = [];
    if (reLeadingDot$1.test(string)) {
      result.push('');
    }
    string.replace(rePropName$1, function(match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar$1, '$1') : (number || match));
    });
    return result;
  });

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey$1(value) {
    if (typeof value == 'string' || isSymbol$1(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */
  function toSource$1(func) {
    if (func != null) {
      try {
        return funcToString$1.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize$1(func, resolver) {
    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT$1);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize$1.Cache || MapCache$1);
    return memoized;
  }

  // Assign cache to `_.memoize`.
  memoize$1.Cache = MapCache$1;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq$1(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray$1 = Array.isArray;

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction$1(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject$1(value) ? objectToString$1.call(value) : '';
    return tag == funcTag$1 || tag == genTag$1;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject$1(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike$1(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol$1(value) {
    return typeof value == 'symbol' ||
      (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString$1(value) {
    return value == null ? '' : baseToString$1(value);
  }

  /**
   * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
   * it's created. Arrays are created for missing index properties while objects
   * are created for all other missing properties. Use `_.setWith` to customize
   * `path` creation.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.set(object, 'a[0].b.c', 4);
   * console.log(object.a[0].b.c);
   * // => 4
   *
   * _.set(object, ['x', '0', 'y', 'z'], 5);
   * console.log(object.x[0].y.z);
   * // => 5
   */
  function set$1(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
  }

  var lodash_set = set$1;

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0

  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.

  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */
  /* global Reflect, Promise */

  var extendStatics = function(d, b) {
      extendStatics = Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
          function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
      return extendStatics(d, b);
  };

  function __extends(d, b) {
      extendStatics(d, b);
      function __() { this.constructor = d; }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                  t[p[i]] = s[p[i]];
          }
      return t;
  }

  function __decorate(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
      else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  }

  function __param(paramIndex, decorator) {
      return function (target, key) { decorator(target, key, paramIndex); }
  }

  function __metadata(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
  }

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  function __exportStar(m, exports) {
      for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }

  function __values(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
          next: function () {
              if (o && i >= o.length) o = void 0;
              return { value: o && o[i++], done: !o };
          }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  function __spread() {
      for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read(arguments[i]));
      return ar;
  }

  function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
      return r;
  }
  function __await(v) {
      return this instanceof __await ? (this.v = v, this) : new __await(v);
  }

  function __asyncGenerator(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = generator.apply(thisArg, _arguments || []), i, q = [];
      return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
      function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
      function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
      function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
      function fulfill(value) { resume("next", value); }
      function reject(value) { resume("throw", value); }
      function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
  }

  function __asyncDelegator(o) {
      var i, p;
      return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
      function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
  }

  function __asyncValues(o) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var m = o[Symbol.asyncIterator], i;
      return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
      function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
      function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
  }

  function __makeTemplateObject(cooked, raw) {
      if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
      return cooked;
  }
  function __importStar(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
      result.default = mod;
      return result;
  }

  function __importDefault(mod) {
      return (mod && mod.__esModule) ? mod : { default: mod };
  }

  function __classPrivateFieldGet(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
  }

  function __classPrivateFieldSet(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
  }

  var tslib_es6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    __extends: __extends,
    get __assign () { return __assign; },
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet
  });

  var Cache_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  /**
   * Simple cache implementation
   */
  var Cache = /** @class */ (function () {
      function Cache() {
          this.data = {};
          this.pending = {};
      }
      Cache.prototype.put = function (key, value) {
          var previousValue = this.data[key];
          this.data[key] = value;
          return previousValue;
      };
      Cache.prototype.get = function (key) {
          return this.data[key];
      };
      Cache.prototype.remove = function (key) {
          var previousValue = this.data[key];
          delete this.data[key];
          return previousValue;
      };
      Cache.prototype.removeAll = function () {
          this.data = {};
      };
      /**
       * Gets a value from the cache or invokes the callback to populate the value
       * with the result of a promise. If invoked multiple times, it will return the promise
       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
       *
       * @param key cache key
       * @param callback returns a Promise to populate the cache with
       * @returns Promise<*> a promise with the cached value
       */
      Cache.prototype.refreshIfAbsent = function (key, callback) {
          if (this.data.hasOwnProperty(key)) {
              return Promise.resolve(this.data[key]);
          }
          return this.refresh(key, callback);
      };
      /**
       * Invokes the callback to populate the value with the result of a promise.
       * If invoked multiple times, it will return the promise
       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
       *
       * @param key cache key
       * @param callback returns a Promise to populate the cache with
       * @returns Promise<*> a promise with the cached value
       */
      Cache.prototype.refresh = function (key, callback) {
          var _this = this;
          // Check if the callback is already pending for this key
          var pending = this.pending[key];
          if (pending) {
              return pending;
          }
          pending = callback();
          this.pending[key] = pending;
          return pending.then(function (value) {
              delete _this.pending[key];
              _this.put(key, value);
              return value;
          });
      };
      return Cache;
  }());
  exports.default = Cache;

  });

  unwrapExports(Cache_1);

  var Registry_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Cache_1$1 = tslib_es6.__importDefault(Cache_1);
  exports.SERVICE_REGISTRY_PATH = '/api/portal/v1/client/config';
  var PORTAL_SERVICE_NAME = 'portal_service';
  var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
  var DEFAULT_CONFIG = {
      host: '',
      cache: new Cache_1$1.default(),
  };
  var Registry = /** @class */ (function () {
      function Registry(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
      }
      // Get the underlying registry cache
      Registry.prototype.getCache = function () {
          return this.config.cache;
      };
      Registry.prototype.getRegistry = function () {
          var _this = this;
          return this.config.cache.refreshIfAbsent('registry', function () {
              var serviceRegistryUrl = _this.getHost();
              serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
              var config = {
                  method: 'GET',
                  mode: 'cors',
                  credentials: 'include',
                  headers: {
                      'Content-Type': 'application/json',
                  },
              };
              return fetch(serviceRegistryUrl, config).then(function (resp) {
                  if (!resp.ok) {
                      return Promise.reject(resp);
                  }
                  return resp.json().then(function (data) {
                      var dataResponse = tslib_es6.__assign({ data: data }, resp);
                      var registry = data.registry;
                      // Optimization - also stuff the client config URL into the cache.
                      // Sometimes, this URL can be different if it's requested from the same domain.
                      var portalService = registry.services[PORTAL_SERVICE_NAME];
                      if (portalService) {
                          var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH);
                          _this.config.cache.put(clientConfigUrl, dataResponse);
                      }
                      return dataResponse;
                  });
              });
          }).then(function (resp) {
              return resp.data.registry;
          });
      };
      Registry.prototype.getUrl = function (serviceName, path, version) {
          var _this = this;
          if (path === void 0) { path = ''; }
          return this.getRegistry().then(function (data) {
              var service = data.services[serviceName];
              if (service === undefined) {
                  throw new Error("Unable to find service '" + serviceName + "'");
              }
              return service;
          }).then(function (service) {
              return _this.createServiceUrl(service, path, version);
          });
      };
      Registry.prototype.getServiceBaseUrl = function (service, version) {
          var baseUrl = service.base_sv_url;
          if (!baseUrl) {
              // unversioned service - simply return regular service url
              return service.sv_url;
          }
          if (version === undefined) {
              // Use configured version if present
              // if(apiVersions[serviceName]) {
              //  version = apiVersions[serviceName];
              // Fallback to version 1 (keeps backwards comparability and generally safe)
              version = 1;
          }
          return this.joinUrlParts(baseUrl, 'v' + version);
      };
      Registry.prototype.getServiceHostUrl = function (service) {
          // Inspired by https://gist.github.com/jlong/2428561
          var parser = document.createElement('a');
          parser.href = service.sv_url;
          return parser.protocol + "//" + parser.host;
      };
      Registry.prototype.createServiceUrl = function (service, path, version) {
          var base;
          if (path.charAt(0) === '/') {
              // Host absolute URL
              base = this.getServiceHostUrl(service);
          }
          else {
              // Service relative URL
              base = this.getServiceBaseUrl(service, version);
          }
          return this.joinUrlParts(base, path);
      };
      /**
       * Determines the registry host in the following order,
       * 1. Uses the configured host if set
       * 2. If a PrintOS subdomain is detected as the current hostname,
       *    the base domain is returned.
       *    For example, if location.hostname is 'app.www.printos.com',
       *    then 'www.printos.com' is returned.
       * 3. Return an empty string otherwise (resulting in a registry call relative
       *    to the current host).
       */
      Registry.prototype.getHost = function () {
          if (this.config.host) {
              // Ensure https
              if (this.config.host.indexOf('https://') !== 0) {
                  this.config.host = 'https://' + this.config.host;
              }
              return this.config.host;
          }
          return '';
      };
      Registry.prototype.joinUrlParts = function (a, b) {
          if (!b) {
              return a;
          }
          if (b.charAt(0) === '/') {
              // Prevent double slashes by ensuring part b doesn't have a slash
              b = b.substr(1);
          }
          if (a.charAt(a.length - 1) === '/') {
              return a + b;
          }
          return a + '/' + b;
      };
      return Registry;
  }());
  exports.default = Registry;

  });

  unwrapExports(Registry_1);
  var Registry_2 = Registry_1.SERVICE_REGISTRY_PATH;

  var Http_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Registry_1$1 = tslib_es6.__importDefault(Registry_1);
  var DEFAULT_CONFIG = {
      registry: new Registry_1$1.default(),
  };
  var Http = /** @class */ (function () {
      function Http(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
          // Use registry cache by default to cache the registry efficiently
          this.config.cache = this.config.cache || this.config.registry.getCache();
      }
      Http.prototype.fetchJsonResponse = function (config) {
          var _this = this;
          var url = Http.formatUrl(config);
          var fetchConfig = {
              method: config.method,
              mode: 'cors',
              credentials: config.credentials ? config.credentials : 'include',
              headers: {},
          };
          if (config.data !== undefined && config.data !== null) {
              if (config.data instanceof FormData) {
                  fetchConfig.body = config.data;
                  // fetchConfig.headers['Content-Type'] = 'multipart/form-data';
              }
              else {
                  fetchConfig.body = JSON.stringify(config.data);
                  fetchConfig.headers['Content-Type'] = 'application/json';
              }
          }
          return fetch(url, fetchConfig).then(function (resp) {
              if (_this.responseInterceptor) {
                  return _this.responseInterceptor(resp, config);
              }
              return resp;
          }).then(function (resp) {
              if (!resp.ok) {
                  return Promise.reject(Object.assign(resp, { data: null }));
              }
              if (resp.status === 204) {
                  return Promise.resolve(Object.assign(resp, { data: null }));
              }
              var contentType = resp.headers.get('Content-Type');
              if (contentType === 'text/plain' || config.responseType === 'text') {
                  return resp.text().then(function (data) {
                      // Extend response to include data
                      return Object.assign(resp, { data: data });
                  });
              }
              return resp.json().then(function (data) {
                  // Extend response to include data
                  return Object.assign(resp, { data: data });
              });
          });
      };
      Http.formatUrl = function (config) {
          var url = config.url;
          if (config.params) {
              if (url.includes('?')) {
                  url += '&';
              }
              else {
                  url += '?';
              }
              url += Http.getQueryString(config.params);
          }
          return url;
      };
      // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
      Http.getQueryString = function (params) {
          return Object.keys(params).map(function (k) {
              var param = params[k];
              if (Array.isArray(param)) {
                  return param
                      .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
                      .join('&');
              }
              return encodeURIComponent(k) + "=" + encodeURIComponent(param);
          }).join('&');
      };
      Http.prototype.request = function (config) {
          var _this = this;
          if (config === void 0) { config = {}; }
          if (config.cache === true) {
              return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
                  return _this.fetchJsonResponse(config);
              });
          }
          if (config.cache === 'refresh') {
              return this.config.cache.refresh(Http.formatUrl(config), function () {
                  return _this.fetchJsonResponse(config);
              });
          }
          return this.fetchJsonResponse(config);
      };
      Http.prototype.serviceRequest = function (serviceName, path, config) {
          var _this = this;
          if (config === void 0) { config = {}; }
          return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
              config.url = url;
              return _this.request(config);
          });
      };
      //
      // Shortcut methods
      //
      Http.prototype.get = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'GET';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.post = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'POST';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.put = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'PUT';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.patch = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'PATCH';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.delete = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'DELETE';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.head = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'HEAD';
          return this.serviceRequest(serviceName, path, config);
      };
      return Http;
  }());
  exports.default = Http;

  });

  unwrapExports(Http_1);

  var Preferences_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Http_1$1 = tslib_es6.__importDefault(Http_1);
  var DEFAULT_CONFIG = {
      http: new Http_1$1.default(),
  };
  var Preferences = /** @class */ (function () {
      function Preferences(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_es6.__assign(tslib_es6.__assign({}, DEFAULT_CONFIG), config);
      }
      Preferences.prototype.get = function (path, cache) {
          if (path === void 0) { path = null; }
          if (cache === void 0) { cache = true; }
          var reqPath = 'preferences';
          if (path) {
              reqPath += '/' + path;
          }
          return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.update = function (prefs) {
          return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.patch = function (path, prefs) {
          return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.delete = function (path) {
          return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.deleteAll = function () {
          return this.config.http.delete('portal_service', 'preferences', { version: 2 });
      };
      return Preferences;
  }());
  exports.default = Preferences;

  });

  unwrapExports(Preferences_1);

  var Locale_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var Locale = /** @class */ (function () {
      function Locale() {
          this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
      }
      Locale.prototype.getCookieValue = function (cookieName) {
          var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
          if (match) {
              return decodeURIComponent(match[2]);
          }
          return null;
      };
      Locale.prototype.getBestFit = function () {
          var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
          if (cookie && cookie.locale) {
              return cookie.locale.split('-')[0];
          }
          return window.navigator.language.split('-')[0];
      };
      return Locale;
  }());
  exports.default = Locale;

  });

  unwrapExports(Locale_1);

  var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Cache_1$1 = tslib_es6.__importDefault(Cache_1);
  var Registry_1$1 = tslib_es6.__importDefault(Registry_1);
  var Http_1$1 = tslib_es6.__importDefault(Http_1);
  var Preferences_1$1 = tslib_es6.__importDefault(Preferences_1);
  var Locale_1$1 = tslib_es6.__importDefault(Locale_1);
  // TODO: move into Registry and have it listen for blue ready
  function getRegistryHost() {
      var host = '';
      if (window.printos &&
          window.printos.blue &&
          window.printos.blue.ui &&
          window.printos.blue.ui.registry) {
          host = window.printos.blue.ui.registry.host;
      }
      return host;
  }
  exports.cache = new Cache_1$1.default();
  exports.registry = new Registry_1$1.default({
      cache: exports.cache,
      host: getRegistryHost(),
  });
  exports.http = new Http_1$1.default({
      cache: exports.cache,
      registry: exports.registry
  });
  exports.preferences = new Preferences_1$1.default({ http: exports.http });
  exports.locale = new Locale_1$1.default();

  });

  unwrapExports(dist);
  var dist_1 = dist.cache;
  var dist_2 = dist.registry;
  var dist_3 = dist.http;
  var dist_4 = dist.preferences;
  var dist_5 = dist.locale;

  /* src/ViewNav.svelte generated by Svelte v2.16.0 */

  function viewName(_ref) {
    var selectedId = _ref.selectedId,
        views = _ref.views;

    if (!selectedId) {
      return '';
    }

    var selectedView = views.find(function (view) {
      return view.id === selectedId;
    });

    if (!selectedView) {
      for (var i = 0; i < views.length; i++) {
        if (!views[i].children) {
          continue;
        }

        selectedView = views[i].children.find(function (childView) {
          return childView.id === selectedId;
        });

        if (selectedView) {
          break;
        }
      }
    } //this.set({ selectedParentId });


    return selectedView ? selectedView.name : '';
  }

  function data() {
    return {
      menuExpanded: false,
      views: [],
      keyEventListener: null,
      selectedId: null,
      selectedParentId: null,
      selectedGrandParentId: null,
      isXS: false,
      isNavUX: false,
      responsiveExpanded: false,
      resizeListener: null,
      toggleListener: null,
      expandedPrefs: null,
      hideNav: false,
      timeoutId: null,
      showTooltips: true
    };
  }
  var methods = {
    handleMouseOver: function handleMouseOver(event) {
      var _this = this;

      this.set({
        showTooltips: true
      });

      var _this$get = this.get(),
          timeoutId = _this$get.timeoutId,
          menuExpanded = _this$get.menuExpanded;

      if (menuExpanded) {
        return;
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(function () {
        _this.set({
          menuExpanded: true,
          timeoutId: null
        });
      }, 2000);
      this.set({
        timeoutId: timeoutId
      });
    },
    handleMouseLeave: function handleMouseLeave(event) {
      var _this$get2 = this.get(),
          timeoutId = _this$get2.timeoutId;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      collapseAllSubViews.call(this);
      this.set({
        timeoutId: null,
        menuExpanded: false
      });
    },
    hideTooltips: function hideTooltips() {
      var _this$get3 = this.get(),
          timeoutId = _this$get3.timeoutId;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      this.set({
        showTooltips: false
      });
    },
    hideAndCollapse: function hideAndCollapse() {
      var _this$get4 = this.get(),
          timeoutId = _this$get4.timeoutId;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      collapseAllSubViews.call(this);
      this.set({
        showTooltips: false,
        menuExpanded: false
      });
    },
    toggleResponsive: function toggleResponsive() {
      var _this$get5 = this.get(),
          responsiveExpanded = _this$get5.responsiveExpanded;

      this.set({
        responsiveExpanded: !responsiveExpanded
      });
    },
    toggleNav: function toggleNav(event) {
      event.stopPropagation();

      var _this$get6 = this.get(),
          views = _this$get6.views,
          menuExpanded = _this$get6.menuExpanded,
          timeoutId = _this$get6.timeoutId;

      if (timeoutId) {
        clearTimeout(timeoutId);
        this.set({
          timeoutId: null
        });
      }

      menuExpanded = !menuExpanded;
      this.set({
        views: views,
        menuExpanded: menuExpanded
      });
    },
    expandNav: function expandNav(event) {
      var _this$get7 = this.get(),
          views = _this$get7.views,
          timeoutId = _this$get7.timeoutId;

      if (timeoutId) {
        clearTimeout(timeoutId);
        this.set({
          timeoutId: null
        });
      }

      this.set({
        views: views,
        menuExpanded: true
      });
    },
    viewClicked: function viewClicked(event, view) {
      event.stopPropagation();

      var _this$get8 = this.get(),
          views = _this$get8.views,
          menuExpanded = _this$get8.menuExpanded,
          timeoutId = _this$get8.timeoutId;

      if (timeoutId) {
        clearTimeout(timeoutId);
        this.set({
          timeoutId: null
        });
      }

      if (view.childViews && view.childViews.length > 0) {
        var myView = views.find(function (v) {
          return view.id === v.id;
        });
        myView.isExpanded = !myView.isExpanded;
        this.set({
          views: views,
          menuExpanded: true
        });
        event.preventDefault();
        return;
      }

      collapseAllSubViews.call(this);
      this.set({
        showTooltips: false,
        menuExpanded: false,
        responsiveExpanded: false
      }); // Adapted from vue-router: https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L105-L122
      // don't redirect with control keys

      if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
        return;
      } // don't redirect when preventDefault called


      if (event.defaultPrevented) {
        return;
      } // don't redirect on right click


      if (event.button !== undefined && event.button !== 0) {
        return;
      } // don't redirect if `target="_blank"`


      if (event.currentTarget && event.currentTarget.getAttribute) {
        var target = event.currentTarget.getAttribute('target');

        if (/\b_blank\b/i.test(target)) {
          return;
        }
      }

      this.fire('viewClicked', {
        event: event,
        view: view
      });
    },
    updateSelection: function updateSelection() {
      var _this$get9 = this.get(),
          selectedId = _this$get9.selectedId,
          selectedParentId = _this$get9.selectedParentId,
          selectedGrandParentId = _this$get9.selectedGrandParentId,
          views = _this$get9.views;

      if (!selectedId || views.length === 0) {
        return;
      }

      selectedParentId = null;
      selectedGrandParentId = null;
      var selectedView = views.find(function (view) {
        return view.id === selectedId;
      });

      if (selectedView) {
        selectedParentId = selectedView.id;
      } else {
        for (var i = 0; i < views.length; i++) {
          if (!views[i].children) {
            continue;
          }

          for (var j = 0; j < views[i].children.length; j++) {
            var childView = views[i].children[j];

            if (childView.id === selectedId) {
              selectedParentId = views[i].id;
              break;
            } else {
              if (childView.children) {
                var grandChild = childView.children.find(function (g) {
                  return g.id === selectedId;
                });

                if (grandChild) {
                  selectedParentId = childView.id;
                  selectedGrandParentId = views[i].id;
                  break;
                }
              }
            }
          }
        }
      }

      this.set({
        selectedParentId: selectedParentId,
        selectedGrandParentId: selectedGrandParentId
      });
    }
  };

  function oncreate() {
    //Get appId, orgId, preferences
    //Store preferences in data
    this.set({
      preferenceService: dist_4
    });
    var toggleListener = this.toggleResponsive.bind(this);
    window.addEventListener('posb-view-nav-toggle-clicked', toggleListener);
    this.set({
      toggleListener: toggleListener
    });
  }

  function ondestroy() {
    var _this$get10 = this.get(),
        resizeListener = _this$get10.resizeListener;

    window.removeEventListener('resize', resizeListener);
    window.removeEventListener('posb-viewnav-toggle-clicked', toggleListener);
  }

  function onstate(_ref2) {
    var changed = _ref2.changed,
        current = _ref2.current,
        previous = _ref2.previous;

    if (changed.selectedId) {
      this.updateSelection();
    }

    if (changed.views) {
      // get preferences
      var _this$get11 = this.get(),
          views = _this$get11.views,
          resizeListener = _this$get11.resizeListener;

      if (views && views.length > 0) {
        // get expanded preferences let expandedPreferences = get(preferences, 'orgId.appId.viewNav.expanded', []);
        views.forEach(function (view) {
          view.childViews = [];

          if (view.children) {
            view.children.forEach(function (childView) {
              var showInNav = lodash_get(childView, 'showInNav', true);

              if (showInNav) {
                view.childViews.push(childView);
              }
            });
          } // If expandedPreferences.contains(view.id) then view.isExpanded = true;

        });

        if (!resizeListener) {
          resizeListener = handleWindowResize.bind(this);
          handleWindowResize.call(this);
          window.addEventListener('resize', resizeListener);
        }

        this.set({
          views: views,
          resizeListener: resizeListener
        });
        this.updateSelection();
      }
    }
  }

  function slideRight(node, _ref3) {
    var _ref3$delay = _ref3.delay,
        delay = _ref3$delay === void 0 ? 0 : _ref3$delay,
        _ref3$duration = _ref3.duration,
        duration = _ref3$duration === void 0 ? 250 : _ref3$duration,
        _ref3$easing = _ref3.easing;
    var style = window.getComputedStyle(node);
    var width = window.parseFloat(style.width);
    return {
      delay: delay,
      duration: duration,
      css: function css(t) {
        return "width: ".concat(t * width, "px;");
      }
    };
  }
  var slideDown = slide;

  function positionDescription(node) {
    var viewContent = node.closest('.view-content');

    var mouseEnterListener = function mouseEnterListener() {
      var viewContentRect = viewContent.getBoundingClientRect();
      node.style.top = "".concat(viewContentRect.top, "px"); // Set display here instead of in CSS to ensure positioning

      node.style.display = 'inherit';
    };

    var mouseLeaveListener = function mouseLeaveListener() {
      node.style.display = '';
    };

    viewContent.addEventListener('mouseenter', mouseEnterListener);
    viewContent.addEventListener('mouseleave', mouseLeaveListener);
    return {
      destroy: function destroy() {
        viewContent.removeEventListener('mouseenter', mouseEnterListener);
        viewContent.removeEventListener('mouseleave', mouseLeaveListener);
      }
    };
  }

  function addHref(node, href) {
    if (href) {
      node.setAttribute('href', href);
    }
  }

  function handleWindowResize() {
    var isXS = window.innerWidth < 600;
    lodash_set(window, 'printos.blue.ui.responsiveMenu', isXS);
    this.set({
      isXS: isXS
    });
  }

  function collapseAllSubViews() {
    var _this$get12 = this.get(),
        views = _this$get12.views;

    views.forEach(function (view) {
      if (view.childViews && view.childViews.length > 0) {
        view.isExpanded = false;
      }
    });
    this.set({
      views: views
    });
  }

  function add_css() {
    var style = createElement("style");
    style.id = 'svelte-123oly2-style';
    style.textContent = ".pros-view.svelte-123oly2{display:flex;flex-direction:column;box-sizing:border-box;min-width:100%;min-height:100%}@media(max-width: 1199px){.pros-view.svelte-123oly2{padding:0 1%}}.pros-view-nav.svelte-123oly2{position:relative;width:60px;height:100%;font-family:Roboto, \"Helvetica Neue\", sans-serif;font-size:16px;box-sizing:border-box}.pros-view-nav.hideNav.svelte-123oly2{display:none}.pros-view-nav.svelte-123oly2 .view-content-container.svelte-123oly2{overflow:hidden}.pros-view-nav.is-xs.svelte-123oly2{width:0}.pros-view-nav.is-xs.svelte-123oly2 .pros-view-nav-content.svelte-123oly2{width:0;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25)}.pros-view-nav.is-xs.svelte-123oly2 .pros-view-nav-content.responsive-expanded.svelte-123oly2{width:250px}.pros-view-nav.svelte-123oly2 .pros-view-nav-content.svelte-123oly2{position:absolute;left:0;top:0;bottom:0;transition:width 0.25s ease-out;width:60px;z-index:30;background-color:#FFFFFF;border-right:1px solid #CCCCCC;overflow:auto;scrollbar-color:#CCCCCC transparent;scrollbar-width:thin}.pros-view-nav.svelte-123oly2 .pros-view-nav-content.expanded.svelte-123oly2:not(.is-xs){width:250px;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25)}.pros-view-nav.svelte-123oly2 .pros-view-nav-content.expanded:not(.is-xs) .child-views .view-content.svelte-123oly2{padding-left:64px}.pros-view-nav.svelte-123oly2 svg{fill:currentColor;width:100%;height:100%;pointer-events:none}.pros-view-nav.svelte-123oly2 .view-name-tooltip.svelte-123oly2{display:none;position:fixed;border:1px solid #F3F3F3;border-radius:3px;max-width:200px;min-width:100px;padding:8px;transform:translate(64px, 0);background-color:#FFFFFF;color:#5A5A5A;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25);overflow:hidden}.pros-view-nav.svelte-123oly2 .view-description.svelte-123oly2{display:none;position:fixed;border:1px solid #F3F3F3;border-radius:3px;max-width:240px;padding:8px;transform:translate(254px, 0);background-color:#f4f4f4;color:#5A5A5A;box-shadow:2px 2px 3px 0 rgba(0, 0, 0, 0.25);overflow:hidden;word-break:break-word;overflow-wrap:anywhere}.pros-view-nav.svelte-123oly2 .child-views .view-content .view-name-tooltip.svelte-123oly2{transform:translate(56px, 0)}.pros-view-nav.svelte-123oly2 .child-views .view-content .view-description.svelte-123oly2{transform:translate(190px, 0)}.pros-view-nav.svelte-123oly2 .view-content.svelte-123oly2{position:relative;display:flex;justify-content:flex-start;align-items:center;height:50px;cursor:pointer}.pros-view-nav.svelte-123oly2 .view-content.svelte-123oly2:hover{background-color:#EEEEEE}.pros-view-nav.svelte-123oly2 .view-content a.svelte-123oly2{line-height:50px}.pros-view-nav.svelte-123oly2 .view-content.is-nav-ux .view-link .view-icon.svelte-123oly2{height:32px;line-height:32px}.pros-view-nav.svelte-123oly2 .view-content .view-link.svelte-123oly2{cursor:pointer;display:flex;justify-content:flex-start;align-items:center;width:100%;text-decoration:none;color:#666}.pros-view-nav.svelte-123oly2 .view-content .view-link .view-name.svelte-123oly2{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1}.pros-view-nav.svelte-123oly2 .view-content .view-link .view-icon-container.svelte-123oly2{width:60px;height:100%;flex-shrink:0}.pros-view-nav.svelte-123oly2 .view-content .view-link .view-icon.svelte-123oly2{height:24px;width:auto;line-height:24px}.pros-view-nav.svelte-123oly2 .view-content .expand-icon.svelte-123oly2{position:absolute;right:-4px;height:24px;width:24px;color:#666;transition:transform .5s ease,-webkit-transform .5s ease;transform:rotate(180deg)}.pros-view-nav.svelte-123oly2 .view-content .expand-icon.expanded.svelte-123oly2{transform:rotate(0)}.pros-view-nav.svelte-123oly2 .view-content.selected.svelte-123oly2{background-color:rgba(0, 150, 214, 0.1)}.pros-view-nav.svelte-123oly2 .view-content.selected .selected-indicator.svelte-123oly2{display:inherit}.pros-view-nav.svelte-123oly2 .view-content.selected .view-link.svelte-123oly2{color:#0096d6}.pros-view-nav.svelte-123oly2 .view-content .selected-indicator.svelte-123oly2{display:none;position:absolute;left:0;top:0;background-color:#0096d6;width:2px;height:100%}.pros-view-nav.svelte-123oly2 .child-views .view-content.svelte-123oly2{padding-left:8px}.pros-view-nav.svelte-123oly2 ::-webkit-scrollbar{width:2px}";
    append(document.head, style);
  }

  function click_handler_1(event) {
    var _this$_svelte = this._svelte,
        component = _this$_svelte.component,
        ctx = _this$_svelte.ctx;
    component.viewClicked(event, ctx.childView);
  }

  function mouseenter_handler_3(event) {
    var component = this._svelte.component;
    component.hideAndCollapse();
  }

  function mouseenter_handler_2(event) {
    var component = this._svelte.component;
    component.hideTooltips();
  }

  function get_each_context_1(ctx, list, i) {
    var child_ctx = Object.create(ctx);
    child_ctx.childView = list[i];
    return child_ctx;
  }

  function click_handler(event) {
    var _this$_svelte2 = this._svelte,
        component = _this$_svelte2.component,
        ctx = _this$_svelte2.ctx;
    component.viewClicked(event, ctx.view);
  }

  function mouseenter_handler_1(event) {
    var component = this._svelte.component;
    component.hideAndCollapse();
  }

  function mouseenter_handler(event) {
    var component = this._svelte.component;
    component.hideTooltips();
  }

  function get_each_context(ctx, list, i) {
    var child_ctx = Object.create(ctx);
    child_ctx.view = list[i];
    return child_ctx;
  }

  function create_main_fragment(component, ctx) {
    var if_block_anchor;
    var if_block = ctx.views && ctx.views.length > 0 && create_if_block(component, ctx);
    return {
      c: function c() {
        if (if_block) if_block.c();
        if_block_anchor = createComment();
      },
      m: function m(target, anchor) {
        if (if_block) if_block.i(target, anchor);
        insert(target, if_block_anchor, anchor);
      },
      p: function p(changed, ctx) {
        if (ctx.views && ctx.views.length > 0) {
          if (if_block) {
            if_block.p(changed, ctx);
          } else {
            if_block = create_if_block(component, ctx);
            if (if_block) if_block.c();
          }

          if_block.i(if_block_anchor.parentNode, if_block_anchor);
        } else if (if_block) {
          groupOutros();
          if_block.o(function () {
            if_block.d(1);
            if_block = null;
          });
        }
      },
      d: function d(detach) {
        if (if_block) if_block.d(detach);

        if (detach) {
          detachNode(if_block_anchor);
        }
      }
    };
  } // (2:0) {#if views && views.length > 0}


  function create_if_block(component, ctx) {
    var div1,
        div0,
        each_blocks_1 = [],
        each_lookup = blankObject(),
        div0_transition,
        current;
    var each_value = ctx.views;

    var get_key = function get_key(ctx) {
      return ctx.view.id;
    };

    for (var i = 0; i < each_value.length; i += 1) {
      var child_ctx = get_each_context(ctx, each_value, i);
      var key = get_key(child_ctx);
      each_blocks_1[i] = each_lookup[key] = create_each_block(component, key, child_ctx);
    }

    function mousemove_handler(event) {
      component.handleMouseOver(event);
    }

    function mouseleave_handler(event) {
      component.handleMouseLeave(event);
    }

    function click_handler_2(event) {
      component.expandNav(event);
    }

    return {
      c: function c() {
        div1 = createElement("div");
        div0 = createElement("div");

        for (i = 0; i < each_blocks_1.length; i += 1) {
          each_blocks_1[i].c();
        }

        addListener(div0, "mousemove", mousemove_handler);
        addListener(div0, "mouseleave", mouseleave_handler);
        div0.className = "pros-view-nav-content svelte-123oly2";
        toggleClass(div0, "expanded", ctx.menuExpanded);
        toggleClass(div0, "responsive-expanded", ctx.responsiveExpanded);
        toggleClass(div0, "is-xs", ctx.isXS);
        addListener(div1, "click", click_handler_2);
        div1.className = "pros-view-nav svelte-123oly2";
        toggleClass(div1, "is-xs", ctx.isXS);
        toggleClass(div1, "hideNav", ctx.hideNav);
      },
      m: function m(target, anchor) {
        insert(target, div1, anchor);
        append(div1, div0);

        for (i = 0; i < each_blocks_1.length; i += 1) {
          each_blocks_1[i].m(div0, null);
        }

        current = true;
      },
      p: function p(changed, ctx) {
        var each_value = ctx.views;
        each_blocks_1 = updateKeyedEach(each_blocks_1, component, changed, get_key, 1, ctx, each_value, each_lookup, div0, destroyBlock, create_each_block, "m", null, get_each_context);

        if (changed.menuExpanded) {
          toggleClass(div0, "expanded", ctx.menuExpanded);
        }

        if (changed.responsiveExpanded) {
          toggleClass(div0, "responsive-expanded", ctx.responsiveExpanded);
        }

        if (changed.isXS) {
          toggleClass(div0, "is-xs", ctx.isXS);
          toggleClass(div1, "is-xs", ctx.isXS);
        }

        if (changed.hideNav) {
          toggleClass(div1, "hideNav", ctx.hideNav);
        }
      },
      i: function i(target, anchor) {
        if (current) return;

        if (component.root._intro) {
          if (div0_transition) div0_transition.invalidate();

          component.root._aftercreate.push(function () {
            if (!div0_transition) div0_transition = wrapTransition(component, div0, slideRight, {}, true);
            div0_transition.run(1);
          });
        }

        this.m(target, anchor);
      },
      o: function o(outrocallback) {
        if (!current) return;
        if (!div0_transition) div0_transition = wrapTransition(component, div0, slideRight, {}, false);
        div0_transition.run(0, function () {
          outrocallback();
          div0_transition = null;
        });
        current = false;
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div1);
        }

        for (i = 0; i < each_blocks_1.length; i += 1) {
          each_blocks_1[i].d();
        }

        removeListener(div0, "mousemove", mousemove_handler);
        removeListener(div0, "mouseleave", mouseleave_handler);

        if (detach) {
          if (div0_transition) div0_transition.abort();
        }

        removeListener(div1, "click", click_handler_2);
      }
    };
  } // (24:10) {:else}


  function create_else_block(component, ctx) {
    var div;
    return {
      c: function c() {
        div = createElement("div");
        div.className = "no-view-icon svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);
      },
      p: noop,
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }
      }
    };
  } // (16:10) {#if view.icon}


  function create_if_block_8(component, ctx) {
    var if_block_anchor;
    var if_block = ctx.view.icon.svg && create_if_block_9(component, ctx);
    return {
      c: function c() {
        if (if_block) if_block.c();
        if_block_anchor = createComment();
      },
      m: function m(target, anchor) {
        if (if_block) if_block.m(target, anchor);
        insert(target, if_block_anchor, anchor);
      },
      p: function p(changed, ctx) {
        if (ctx.view.icon.svg) {
          if (if_block) {
            if_block.p(changed, ctx);
          } else {
            if_block = create_if_block_9(component, ctx);
            if_block.c();
            if_block.m(if_block_anchor.parentNode, if_block_anchor);
          }
        } else if (if_block) {
          if_block.d(1);
          if_block = null;
        }
      },
      d: function d(detach) {
        if (if_block) if_block.d(detach);

        if (detach) {
          detachNode(if_block_anchor);
        }
      }
    };
  } // (17:10) {#if view.icon.svg}


  function create_if_block_9(component, ctx) {
    var div1,
        div0,
        raw_value = ctx.view.icon.svg;
    return {
      c: function c() {
        div1 = createElement("div");
        div0 = createElement("div");
        div0.className = "view-icon svelte-123oly2";
        div1.className = "view-icon-container svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div1, anchor);
        append(div1, div0);
        div0.innerHTML = raw_value;
      },
      p: function p(changed, ctx) {
        if (changed.views && raw_value !== (raw_value = ctx.view.icon.svg)) {
          div0.innerHTML = raw_value;
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div1);
        }
      }
    };
  } // (29:8) {#if view.childViews.length > 0 && menuExpanded}


  function create_if_block_7(component, ctx) {
    var div;
    return {
      c: function c() {
        div = createElement("div");
        div.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" class=\"svelte-123oly2\"><path d=\"M7 14l5-5 5 5z\" class=\"svelte-123oly2\"></path><path d=\"M0 0h24v24H0z\" fill=\"none\" class=\"svelte-123oly2\"></path></svg>";
        div.className = "expand-icon svelte-123oly2";
        toggleClass(div, "expanded", ctx.view.isExpanded);
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);
      },
      p: function p(changed, ctx) {
        if (changed.views) {
          toggleClass(div, "expanded", ctx.view.isExpanded);
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }
      }
    };
  } // (35:8) {#if !menuExpanded && showTooltips && !isXS}


  function create_if_block_6(component, ctx) {
    var div,
        text_value = ctx.view.name,
        text,
        positionDescription_action;
    return {
      c: function c() {
        div = createElement("div");
        text = createText(text_value);
        div._svelte = {
          component: component
        };
        addListener(div, "mouseenter", mouseenter_handler);
        div.className = "view-name-tooltip svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);
        append(div, text);
        positionDescription_action = positionDescription.call(component, div) || {};
      },
      p: function p(changed, ctx) {
        if (changed.views && text_value !== (text_value = ctx.view.name)) {
          setData(text, text_value);
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }

        removeListener(div, "mouseenter", mouseenter_handler);
        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
      }
    };
  } // (40:8) {#if menuExpanded && view.description && showTooltips && !isXS}


  function create_if_block_5(component, ctx) {
    var div,
        wbr,
        text_value = ctx.view.description,
        text,
        positionDescription_action;
    return {
      c: function c() {
        div = createElement("div");
        wbr = createElement("wbr");
        text = createText(text_value);
        wbr.className = "svelte-123oly2";
        div._svelte = {
          component: component
        };
        addListener(div, "mouseenter", mouseenter_handler_1);
        div.className = "view-description svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);
        append(div, wbr);
        append(div, text);
        positionDescription_action = positionDescription.call(component, div) || {};
      },
      p: function p(changed, ctx) {
        if (changed.views && text_value !== (text_value = ctx.view.description)) {
          setData(text, text_value);
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }

        removeListener(div, "mouseenter", mouseenter_handler_1);
        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
      }
    };
  } // (47:6) {#if view.childViews.length > 0 && view.isExpanded}


  function create_if_block_1(component, ctx) {
    var div,
        each_blocks_1 = [],
        each_lookup = blankObject(),
        div_transition,
        current;
    var each_value_1 = ctx.view.childViews;

    var get_key = function get_key(ctx) {
      return ctx.childView.id;
    };

    for (var i = 0; i < each_value_1.length; i += 1) {
      var child_ctx = get_each_context_1(ctx, each_value_1, i);
      var key = get_key(child_ctx);
      each_blocks_1[i] = each_lookup[key] = create_each_block_1(component, key, child_ctx);
    }

    return {
      c: function c() {
        div = createElement("div");

        for (i = 0; i < each_blocks_1.length; i += 1) {
          each_blocks_1[i].c();
        }

        div.className = "child-views svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);

        for (i = 0; i < each_blocks_1.length; i += 1) {
          each_blocks_1[i].m(div, null);
        }

        current = true;
      },
      p: function p(changed, ctx) {
        var each_value_1 = ctx.view.childViews;
        each_blocks_1 = updateKeyedEach(each_blocks_1, component, changed, get_key, 1, ctx, each_value_1, each_lookup, div, destroyBlock, create_each_block_1, "m", null, get_each_context_1);
      },
      i: function i(target, anchor) {
        if (current) return;

        if (component.root._intro) {
          if (div_transition) div_transition.invalidate();

          component.root._aftercreate.push(function () {
            if (!div_transition) div_transition = wrapTransition(component, div, slideDown, {}, true);
            div_transition.run(1);
          });
        }

        this.m(target, anchor);
      },
      o: function o(outrocallback) {
        if (!current) return;
        if (!div_transition) div_transition = wrapTransition(component, div, slideDown, {}, false);
        div_transition.run(0, function () {
          outrocallback();
          div_transition = null;
        });
        current = false;
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }

        for (i = 0; i < each_blocks_1.length; i += 1) {
          each_blocks_1[i].d();
        }

        if (detach) {
          if (div_transition) div_transition.abort();
        }
      }
    };
  } // (62:12) {#if childView.description && showTooltips && !isXS}


  function create_if_block_4(component, ctx) {
    var div,
        wbr,
        text_value = ctx.childView.description,
        text,
        positionDescription_action;
    return {
      c: function c() {
        div = createElement("div");
        wbr = createElement("wbr");
        text = createText(text_value);
        wbr.className = "svelte-123oly2";
        div._svelte = {
          component: component
        };
        addListener(div, "mouseenter", mouseenter_handler_3);
        div.className = "view-description svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);
        append(div, wbr);
        append(div, text);
        positionDescription_action = positionDescription.call(component, div) || {};
      },
      p: function p(changed, ctx) {
        if (changed.views && text_value !== (text_value = ctx.childView.description)) {
          setData(text, text_value);
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }

        removeListener(div, "mouseenter", mouseenter_handler_3);
        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
      }
    };
  } // (55:10) {#if !menuExpanded && showTooltips && !isXS}


  function create_if_block_2(component, ctx) {
    var if_block_anchor;
    var if_block = ctx.timeoutId && create_if_block_3(component, ctx);
    return {
      c: function c() {
        if (if_block) if_block.c();
        if_block_anchor = createComment();
      },
      m: function m(target, anchor) {
        if (if_block) if_block.m(target, anchor);
        insert(target, if_block_anchor, anchor);
      },
      p: function p(changed, ctx) {
        if (ctx.timeoutId) {
          if (if_block) {
            if_block.p(changed, ctx);
          } else {
            if_block = create_if_block_3(component, ctx);
            if_block.c();
            if_block.m(if_block_anchor.parentNode, if_block_anchor);
          }
        } else if (if_block) {
          if_block.d(1);
          if_block = null;
        }
      },
      d: function d(detach) {
        if (if_block) if_block.d(detach);

        if (detach) {
          detachNode(if_block_anchor);
        }
      }
    };
  } // (56:12) {#if timeoutId}


  function create_if_block_3(component, ctx) {
    var div,
        text_value = ctx.childView.name,
        text,
        positionDescription_action;
    return {
      c: function c() {
        div = createElement("div");
        text = createText(text_value);
        div._svelte = {
          component: component
        };
        addListener(div, "mouseenter", mouseenter_handler_2);
        div.className = "view-name-tooltip svelte-123oly2";
      },
      m: function m(target, anchor) {
        insert(target, div, anchor);
        append(div, text);
        positionDescription_action = positionDescription.call(component, div) || {};
      },
      p: function p(changed, ctx) {
        if (changed.views && text_value !== (text_value = ctx.childView.name)) {
          setData(text, text_value);
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div);
        }

        removeListener(div, "mouseenter", mouseenter_handler_2);
        if (positionDescription_action && typeof positionDescription_action.destroy === 'function') positionDescription_action.destroy.call(component);
      }
    };
  } // (49:8) {#each view.childViews as childView (childView.id)}


  function create_each_block_1(component, key_1, ctx) {
    var div2,
        a,
        div0,
        text0_value = ctx.childView.name,
        text0,
        addHref_action,
        text1,
        div1,
        text2,
        div2_id_value;

    function select_block_type_1(ctx) {
      if (!ctx.menuExpanded && ctx.showTooltips && !ctx.isXS) return create_if_block_2;
      if (ctx.childView.description && ctx.showTooltips && !ctx.isXS) return create_if_block_4;
    }

    var current_block_type = select_block_type_1(ctx);
    var if_block = current_block_type && current_block_type(component, ctx);
    return {
      key: key_1,
      first: null,
      c: function c() {
        div2 = createElement("div");
        a = createElement("a");
        div0 = createElement("div");
        text0 = createText(text0_value);
        text1 = createText("\n          ");
        div1 = createElement("div");
        text2 = createText("\n          ");
        if (if_block) if_block.c();
        setAttribute(div0, "pros-tooltip", "");
        div0.className = "view-name svelte-123oly2";
        a.className = "view-link svelte-123oly2";
        div1.className = "selected-indicator svelte-123oly2";
        div2._svelte = {
          component: component,
          ctx: ctx
        };
        addListener(div2, "click", click_handler_1);
        div2.id = div2_id_value = "view-" + ctx.childView.id;
        div2.className = "view-content svelte-123oly2";
        toggleClass(div2, "selected", ctx.childView.id === ctx.selectedId || ctx.childView.id === ctx.selectedParentId);
        this.first = div2;
      },
      m: function m(target, anchor) {
        insert(target, div2, anchor);
        append(div2, a);
        append(a, div0);
        append(div0, text0);
        addHref_action = addHref.call(component, a, ctx.childView.href) || {};
        append(div2, text1);
        append(div2, div1);
        append(div2, text2);
        if (if_block) if_block.m(div2, null);
      },
      p: function p(changed, _ctx) {
        ctx = _ctx;

        if (changed.views && text0_value !== (text0_value = ctx.childView.name)) {
          setData(text0, text0_value);
        }

        if (typeof addHref_action.update === 'function' && changed.views) {
          addHref_action.update.call(component, ctx.childView.href);
        }

        if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block) {
          if_block.p(changed, ctx);
        } else {
          if (if_block) if_block.d(1);
          if_block = current_block_type && current_block_type(component, ctx);
          if (if_block) if_block.c();
          if (if_block) if_block.m(div2, null);
        }

        div2._svelte.ctx = ctx;

        if (changed.views && div2_id_value !== (div2_id_value = "view-" + ctx.childView.id)) {
          div2.id = div2_id_value;
        }

        if (changed.views || changed.selectedId || changed.selectedParentId) {
          toggleClass(div2, "selected", ctx.childView.id === ctx.selectedId || ctx.childView.id === ctx.selectedParentId);
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div2);
        }

        if (addHref_action && typeof addHref_action.destroy === 'function') addHref_action.destroy.call(component);
        if (if_block) if_block.d();
        removeListener(div2, "click", click_handler_1);
      }
    };
  } // (12:4) {#each views as view (view.id)}


  function create_each_block(component, key_1, ctx) {
    var div3,
        div2,
        a,
        text0,
        div0,
        text1_value = ctx.view.name,
        text1,
        addHref_action,
        text2,
        text3,
        div1,
        text4,
        text5,
        div2_id_value,
        text6,
        text7;

    function select_block_type(ctx) {
      if (ctx.view.icon) return create_if_block_8;
      return create_else_block;
    }

    var current_block_type = select_block_type(ctx);
    var if_block0 = current_block_type(component, ctx);
    var if_block1 = ctx.view.childViews.length > 0 && ctx.menuExpanded && create_if_block_7(component, ctx);
    var if_block2 = !ctx.menuExpanded && ctx.showTooltips && !ctx.isXS && create_if_block_6(component, ctx);
    var if_block3 = ctx.menuExpanded && ctx.view.description && ctx.showTooltips && !ctx.isXS && create_if_block_5(component, ctx);
    var if_block4 = ctx.view.childViews.length > 0 && ctx.view.isExpanded && create_if_block_1(component, ctx);
    return {
      key: key_1,
      first: null,
      c: function c() {
        div3 = createElement("div");
        div2 = createElement("div");
        a = createElement("a");
        if_block0.c();
        text0 = createText("\n          ");
        div0 = createElement("div");
        text1 = createText(text1_value);
        text2 = createText("\n        ");
        if (if_block1) if_block1.c();
        text3 = createText("\n        ");
        div1 = createElement("div");
        text4 = createText("\n        ");
        if (if_block2) if_block2.c();
        text5 = createText("\n        ");
        if (if_block3) if_block3.c();
        text6 = createText("\n\n      ");
        if (if_block4) if_block4.c();
        text7 = createText("\n    ");
        setAttribute(div0, "pros-tooltip", "");
        div0.className = "view-name svelte-123oly2";
        a.className = "view-link svelte-123oly2";
        div1.className = "selected-indicator svelte-123oly2";
        div2._svelte = {
          component: component,
          ctx: ctx
        };
        addListener(div2, "click", click_handler);
        div2.id = div2_id_value = "view-" + ctx.view.id;
        div2.className = "view-content svelte-123oly2";
        toggleClass(div2, "selected", ctx.view.id === ctx.selectedId || !ctx.view.isExpanded && (ctx.view.id === ctx.selectedParentId || ctx.view.id === ctx.selectedGrandParentId));
        toggleClass(div2, "is-nav-ux", ctx.isNavUX);
        div3.className = "view-content-container svelte-123oly2";
        this.first = div3;
      },
      m: function m(target, anchor) {
        insert(target, div3, anchor);
        append(div3, div2);
        append(div2, a);
        if_block0.m(a, null);
        append(a, text0);
        append(a, div0);
        append(div0, text1);
        addHref_action = addHref.call(component, a, ctx.view.href) || {};
        append(div2, text2);
        if (if_block1) if_block1.m(div2, null);
        append(div2, text3);
        append(div2, div1);
        append(div2, text4);
        if (if_block2) if_block2.m(div2, null);
        append(div2, text5);
        if (if_block3) if_block3.m(div2, null);
        append(div3, text6);
        if (if_block4) if_block4.i(div3, null);
        append(div3, text7);
      },
      p: function p(changed, _ctx) {
        ctx = _ctx;

        if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) {
          if_block0.p(changed, ctx);
        } else {
          if_block0.d(1);
          if_block0 = current_block_type(component, ctx);
          if_block0.c();
          if_block0.m(a, text0);
        }

        if (changed.views && text1_value !== (text1_value = ctx.view.name)) {
          setData(text1, text1_value);
        }

        if (typeof addHref_action.update === 'function' && changed.views) {
          addHref_action.update.call(component, ctx.view.href);
        }

        if (ctx.view.childViews.length > 0 && ctx.menuExpanded) {
          if (if_block1) {
            if_block1.p(changed, ctx);
          } else {
            if_block1 = create_if_block_7(component, ctx);
            if_block1.c();
            if_block1.m(div2, text3);
          }
        } else if (if_block1) {
          if_block1.d(1);
          if_block1 = null;
        }

        if (!ctx.menuExpanded && ctx.showTooltips && !ctx.isXS) {
          if (if_block2) {
            if_block2.p(changed, ctx);
          } else {
            if_block2 = create_if_block_6(component, ctx);
            if_block2.c();
            if_block2.m(div2, text5);
          }
        } else if (if_block2) {
          if_block2.d(1);
          if_block2 = null;
        }

        if (ctx.menuExpanded && ctx.view.description && ctx.showTooltips && !ctx.isXS) {
          if (if_block3) {
            if_block3.p(changed, ctx);
          } else {
            if_block3 = create_if_block_5(component, ctx);
            if_block3.c();
            if_block3.m(div2, null);
          }
        } else if (if_block3) {
          if_block3.d(1);
          if_block3 = null;
        }

        div2._svelte.ctx = ctx;

        if (changed.views && div2_id_value !== (div2_id_value = "view-" + ctx.view.id)) {
          div2.id = div2_id_value;
        }

        if (changed.views || changed.selectedId || changed.selectedParentId || changed.selectedGrandParentId) {
          toggleClass(div2, "selected", ctx.view.id === ctx.selectedId || !ctx.view.isExpanded && (ctx.view.id === ctx.selectedParentId || ctx.view.id === ctx.selectedGrandParentId));
        }

        if (changed.isNavUX) {
          toggleClass(div2, "is-nav-ux", ctx.isNavUX);
        }

        if (ctx.view.childViews.length > 0 && ctx.view.isExpanded) {
          if (if_block4) {
            if_block4.p(changed, ctx);
          } else {
            if_block4 = create_if_block_1(component, ctx);
            if (if_block4) if_block4.c();
          }

          if_block4.i(div3, text7);
        } else if (if_block4) {
          groupOutros();
          if_block4.o(function () {
            if_block4.d(1);
            if_block4 = null;
          });
        }
      },
      d: function d(detach) {
        if (detach) {
          detachNode(div3);
        }

        if_block0.d();
        if (addHref_action && typeof addHref_action.destroy === 'function') addHref_action.destroy.call(component);
        if (if_block1) if_block1.d();
        if (if_block2) if_block2.d();
        if (if_block3) if_block3.d();
        removeListener(div2, "click", click_handler);
        if (if_block4) if_block4.d();
      }
    };
  }

  function ViewNav(options) {
    var _this2 = this;

    init(this, options);
    this._state = assign(data(), options.data);

    this._recompute({
      selectedId: 1,
      views: 1
    }, this._state);

    this._intro = true;
    this._handlers.state = [onstate];
    this._handlers.destroy = [ondestroy];
    if (!document.getElementById("svelte-123oly2-style")) add_css();
    onstate.call(this, {
      changed: assignTrue({}, this._state),
      current: this._state
    });
    this._fragment = create_main_fragment(this, this._state);

    this.root._oncreate.push(function () {
      oncreate.call(_this2);

      _this2.fire("update", {
        changed: assignTrue({}, _this2._state),
        current: _this2._state
      });
    });

    if (options.target) {
      this._fragment.c();

      this._mount(options.target, options.anchor);

      flush(this);
    }
  }

  assign(ViewNav.prototype, proto);
  assign(ViewNav.prototype, methods);

  ViewNav.prototype._recompute = function _recompute(changed, state) {
    if (changed.selectedId || changed.views) {
      if (this._differs(state.viewName, state.viewName = viewName(state))) changed.viewName = true;
    }
  };

  exports.ViewNav = ViewNav;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ../~/@printos/agnostic-view-nav/dist/view-nav.js
// module id = 80
// module chunks = 0